import { type RefObject, useEffect } from 'react';

type Params = {
  containerRefs: Array<RefObject<HTMLElement | null>>;
  listener: (event: Event) => void;
};

const refContainsTarget = (ref: RefObject<HTMLElement | null>, target: EventTarget | null): boolean =>
  !!(ref.current && target && ref.current.contains(target as HTMLElement));

export const useClickAway = ({ containerRefs, listener }: Params): void => {
  useEffect(() => {
    const enhancedListener = (event: Event) => {
      if (containerRefs.every(ref => !refContainsTarget(ref, event.target))) listener(event);
    };

    globalThis.document?.addEventListener('mousedown', enhancedListener, { capture: true });
    globalThis.document?.addEventListener('focusin', enhancedListener, { capture: true });
    return () => {
      globalThis.document?.removeEventListener('mousedown', enhancedListener, { capture: true });
      globalThis.document?.removeEventListener('focusin', enhancedListener, { capture: true });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listener, ...containerRefs]);
};
